import React from 'react';
import ContentLoader, { IContentLoaderProps } from 'react-content-loader';

export const NotificationsPagePlacholder = (props: IContentLoaderProps) => {
  return (
    <ContentLoader
      {...props}
      viewBox="0 0 840 128"
      backgroundColor="#e7f1fc"
      foregroundColor="#ffffff"
    >
      <circle cx="48" cy="48" r="24" />;
      <rect x="88" y="24" rx="8" ry="8" width="720" height="16" />
      <rect x="88" y="52" rx="8" ry="8" width="340" height="16" />
    </ContentLoader>
  );
};
